import { PlusIcon } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

import { AddAnnouncementForm } from "./add-announcement.form";

export function AddAnnouncementModal() {
  const [isCreateAnnouncementModalOpen, setIsCreateAnnouncementModalOpen] =
    useState(false);

  return (
    <Dialog
      open={isCreateAnnouncementModalOpen}
      onOpenChange={setIsCreateAnnouncementModalOpen}
    >
      <DialogTrigger asChild>
        <Button>
          <PlusIcon className="mr-1 size-4 text-inherit" /> Add Announcement
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>New Announcement</DialogTitle>
        </DialogHeader>
        <AddAnnouncementForm
          onClose={() => setIsCreateAnnouncementModalOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
